import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable} from 'rxjs';
import { environment } from '../../environments/environment';
import { Wopi } from '../models/Wopi';

@Injectable({
  providedIn: 'root'
})
export class WopiService {
 
  private URL_WOPI = environment.apiUrl + "wopi";

  constructor(
    private http: HttpClient
  ) { }

preparar(estado: string, documentoId?: number): Observable<Wopi> {

    let qparams = new HttpParams();
    qparams = qparams.set('e', estado);
    if (documentoId) {
      qparams = qparams.set('did', documentoId);
    }

    return this.http.get<Wopi>(`${this.URL_WOPI}/pt`, { params: qparams });

  }

}

